export enum AUTH_JWT_ACTIONS {
    REFRESH = 'REFRESH',
    REFRESH_MANUAL = 'REFRESH_MANUAL',
    UPDATE_ROLE = 'UPDATE_ROLE',
    UPDATE_JIBBLE_STATUS = 'UPDATE_JIBBLE_STATUS',
  }